/* eslint-disable react/require-default-props */
import React from 'react';
export function BrushawayBody({ children, variant = 'default', className = '' }) {
    const bodyClasses = [
        'qmb-ui-brushaway-body',
        variant !== 'default' ? `qmb-ui-brushaway-body--${variant}` : '',
        className
    ]
        .filter(Boolean)
        .join(' ');
    return React.createElement("div", { className: bodyClasses }, children);
}
